import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { defineState } from 'redux-localstore';

const defaultState = {
  feedback: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('feedback');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.feedback.length > 0 ? action.feedback : [];
  return updateObject(state, {
    feedback: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, feedback: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FEEDBACK_START:
      return fetchStart(state);
    case actionTypes.FETCH_FEEDBACK_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_FEEDBACK_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
